import React from "react";
import NotFound from "../NotFound";
import { RichText } from "prismic-reactjs";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import Podcast from "../slices/Podcast";

export default class ResourcesItemPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      notFound: false
    };
    if (props.prismicCtx) {
      this.fetchPage(props);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.prismicCtx) {
      this.fetchPage(this.props);
    }
  }

  fetchPage(props) {
    return props.prismicCtx.api.getByUID(
      "resources",
      props.match.params.uid,
      {},
      (err, doc) => {
        if (doc) {
          this.setState({ doc });
        } else {
          this.setState({ notFound: !doc });
        }
      }
    );
  }

  renderPodcastList = () => {
    const { doc } = this.state;
    const { body } = doc.data;
    const podcastSlices = body.filter(item => item.slice_type === "podcast");

    return (
      <div className="podcasts">
        {podcastSlices.map((pod, index) => {
          return (
            <Podcast
              title={pod.primary.podcast_title}
              coverUrl={pod.primary.cover.url}
              fileUrl={pod.primary.podcast_file.url}
              key={index}
            />
          );
        })}
      </div>
    );
  };

  render() {
    if (this.state.doc) {
      const { doc } = this.state;

      return (
        <div>
          <PageHeader title={RichText.asText(doc.data.title)} />
          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4 offset-lg-1 order-md-last">
                <a href={doc.data.resource_link.url} target="_blank">
                  <img
                    src={doc.data.main_image.url}
                    alt=""
                    className="img-fluid btn-block mb-5 main-image"
                  />
                </a>
              </div>
              <div className="col-12 col-md-8 col-lg-7 order-md-first">
                {this.renderPodcastList()}
                <div className="content">
                  {RichText.render(
                    doc.data.content,
                    this.props.prismicCtx.linkResolver
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ResourceItemPage.js